import domReady from "@wordpress/dom-ready";

domReady(() => {
    const searchResults = document.querySelectorAll(".vendor-onboarding-search-result");

    searchResults.forEach((result) => {
        const outerLink = result.querySelector('a');
        if (outerLink) {
            const url = outerLink.href;

            result.querySelectorAll('a').forEach(innerLink => {
                innerLink.replaceWith(...innerLink.childNodes);
            });

            const wrapper = document.createElement('a');
            wrapper.href = url;
            wrapper.style.display = 'block';
            wrapper.innerHTML = result.innerHTML;
            result.innerHTML = '';
            result.appendChild(wrapper);
        }
    });
});
